export enum ContractorEnum {
    LEASE = "lease",
    INSURANCE = "insurance",
}
